import axios from "../../utils/axios";

const getVideo = async (videoId) => {
    const response = await axios.get(`/videos/${videoId}`);

    return response.data;
};

export default getVideo;
